import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createRoute,
  deleteRoute,
  getAllRoutes,
  getRouteByEventId,
  updateRoute,
} from "./routes.service";

export const useGetAllRoutes = (options = {}) => {
  return useQuery({
    queryKey: ["jeep-rally-routes"],
    queryFn: getAllRoutes,
    ...options,
  });
};

export const useGetRouteByEventId = (eventId, options = {}) => {
  return useQuery({
    queryKey: ["jeep-rally-routes", eventId],
    queryFn: () => getRouteByEventId(eventId),
    enabled: Boolean(eventId) && options.enabled !== false,
    ...options,
  });
};

export const useCreateRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ payload }) => createRoute(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["jeep-rally-routes"],
      });
    },
  });
};

export const useUpdateRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, payload }) => updateRoute(routeId, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["jeep-rally-routes"] });
    },
  });
};

export const useDeleteRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId }) => deleteRoute(routeId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["jeep-rally-routes"] });
    },
  });
};
